import { useEffect, useRef } from 'react';
import { Locale } from './copy';

export function PatternRequiredDialog({ locale, close, create }: { locale: Locale; close: () => void; create: () => void }): React.JSX.Element {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const opener = document.activeElement as HTMLElement | null;
    ref.current?.showModal();
    return () => { opener?.focus(); };
  }, []);
  const es = locale === 'es';
  return <dialog ref={ref} className="pattern-required-dialog" aria-labelledby="pattern-required-title" onCancel={close}>
    <h2 id="pattern-required-title">{es ? 'Cree un patrón primero' : 'Create a pattern first'}</h2>
    <p>{es ? 'Necesita un patrón guardado antes de crear una partida.' : 'You need a saved pattern before creating a new game.'}</p>
    <div className="button-row"><button type="button" onClick={close}>{es ? 'Cancelar' : 'Cancel'}</button><button type="button" className="primary" onClick={create}>{es ? 'Crear patrón' : 'Create pattern'}</button></div>
  </dialog>;
}
